import React, { useState, useEffect, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@material-ui/core'
import { Page, Header, ObjetoAvatar, SecaoGenerica } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { useVestigioService } from 'hooks/useVestigioService'
import { CardCaso } from 'components/Cards/CardCaso'
import { CardExameSolicitado } from 'components/Cards/CardExameSolicitado'
import { CardRegistroIdentificacao } from 'components/Cards/CardRegistroIdentificacao'
import { CardVestigio } from 'components/Cards/CardVestigio'
import { ExibirArquivo } from 'components/ExibirArquivo'
import { MenuAcoes } from './components/MenuAcoes'
import { useStyles } from './Periciando.styles'
import { ListaInformacoes } from 'views/Informacao/ListaInformacoes'
import { useParams } from 'react-router'

import FingerprintIcon from '@material-ui/icons/Fingerprint'
import WcIcon from '@material-ui/icons/Wc'
import CakeIcon from '@material-ui/icons/Cake'
import ScheduleIcon from '@material-ui/icons/Schedule'

export const Periciando = (props) => {
  const { route } = props
  const router = useRouter()
  const params = useParams()
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const periciandoService = usePericiandoService()
  const vestigioService = useVestigioService()
  const [periciando, setPericiando] = useState(null)
  const [vestigiosExtraidos, setVestigiosExtraidos] = useState(null)
  const [processandoPericiando, setProcessandoPericiando] = useState(false)
  const [registros, setRegistros] = useState(null)
  const [processandoRegistros, setProcessandoRegistros] = useState(false)

  const fetchRegistrosIdentificacao = useCallback(async () => {
    if (params.id) {
      const response = await periciandoService.listarRegistrosIdentificacaoPericiandoAsync(params.id, setProcessandoRegistros)
      setRegistros(response)
    }
  }, [params.id])

  useEffect(() => {
    const fetchPericiandoDetalhado = async () => {
      const result = await periciandoService.listarPericiandoDetalhadoAsync(params.id, setProcessandoPericiando)
      setPericiando(result)
    }
    fetchPericiandoDetalhado()
  }, [params.id])

  useEffect(() => {
    const fetchVestigiosExtraidos = async () => {
      const response = await vestigioService.listarVestigiosExtraidosDePericiandoAsync(params.id, setProcessandoPericiando)
      setVestigiosExtraidos(response)
    }

    if (periciando && periciando.id) {
      fetchVestigiosExtraidos()
    }
  }, [periciando])

  useEffect(() => {
    fetchRegistrosIdentificacao()
  }, [fetchRegistrosIdentificacao])

  const handleClickCaso = (id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/detalhar/${id}`)
    }
  }

  const handleClickExameSolicitado = (id) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`)
  }

  const handleClickVestigio = (id, novaTab) => {
    if (novaTab) {
      window.open(`/casos/caso/vestigio/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/vestigio/detalhar/${id}`)
    }
  }

  const calcularIdade = (dataNascimento) => {
    if (dataNascimento === null) {
      return ''
    } else {
      const dataNascimentoDate = new Date(dataNascimento)
      const hoje = new Date()

      let idade = hoje.getFullYear() - dataNascimentoDate.getFullYear()

      // Verifica se o aniversário já ocorreu este ano
      if (hoje.getMonth() < dataNascimentoDate.getMonth() || (hoje.getMonth() === dataNascimentoDate.getMonth() && hoje.getDate() < dataNascimentoDate.getDate())) {
        idade--
      }

      return `- ${idade} ANOS`
    }
  }

  const textoNaturezaSolicitacao = (valor) => {
    if (!valor) return ''
    if (valor === 'LESAO_CORPORAL_CULPOSA') return 'Lesão Corporal Culposa'
    if (valor === 'LESAO_CORPORAL_DOLOSA') return 'Lesão Corporal Dolosa'
    if (valor === 'VIAS_DE_FATO') return 'Vias de Fato'
    if (valor === 'AMEACA') return 'Ameaça'
    if (valor === 'INJURIA') return 'Injúria'
    if (valor === 'MARIA_DA_PENHA') return 'Maria da Penha'
    if (valor === 'PESSOA_COM_DEFICIENCIA') return 'Estatuto da Pessoa com Deficiência'
    if (valor === 'ECA') return 'ECA'
    if (valor === 'IDOSO') return 'Estatuto do Idoso'
    if (valor === 'TRANSITO') return 'Crime de Trânsito'
    if (valor === 'ESTUPRO_VULNERAVEL_I') return 'Estupro de Vulnerável I'
    if (valor === 'ESTUPRO_VULNERAVEL_II') return 'Estupro de Vulnerável II'
    if (valor === 'ESTUPRO_NAO_VULNERAVEL') return 'Estupro (não vulnerável)'
    if (valor === 'PROJETO_ABRACAR') return 'Projeto Abraçar'
    if (valor === 'OUTRO') return 'Outra natureza'
    return ''
  }
  const textoCategoriaPrisao = (valor) => {
    if (!valor) return ''
    if (valor === 'LESAO_CORPORAL_CULPOSA') return 'Lesão Corporal Culposa'
    if (valor === 'LESAO_CORPORAL_DOLOSA') return 'Lesão Corporal Dolosa'
    if (valor === 'VIAS_DE_FATO') return 'Vias de Fato'
    if (valor === 'MARIA_DA_PENHA') return 'Crime tipificado na Maria da Penha'
    if (valor === 'ECA') return 'Crime tipificado no ECA'
    if (valor === 'ESTATUTO_IDOSO') return 'Crime Tipificado no Estatuto do Idoso'
    if (valor === 'PESSOA_DEFICIENCIA') return 'Crime Tipificado no Estatuto da Pessoa com Deficiência'
    if (valor === 'DIGNIDADE_SEXUAL') return 'Crime contra a dignidade sexual'
    if (valor === 'HONRA') return 'Crime contra a Honra'
    if (valor === 'RACISMO') return 'Crime de Racismo'
    if (valor === 'DOMESTICA') return 'Violência doméstica'
    if (valor === 'PSICOLOGICA') return 'Violência Psicológica'
    if (valor === 'DESOBEDIENCIA') return 'Desobediência'
    if (valor === 'DESACATO') return 'Desacato'
    if (valor === 'INJURIA') return 'Injúria'
    if (valor === 'CALUNIA') return 'Calúnia'
    if (valor === 'DIFAMACAO') return 'Difamação'
    if (valor === 'RECEPTACAO_SIMPLES') return 'Receptação simples'
    if (valor === 'RECEPTACAO_QUALIFICADA') return 'Receptação Qualificada'
    if (valor === 'CRIME_DE_DANO') return 'Crime de Dano'
    if (valor === 'ROUBO') return 'Roubo'
    if (valor === 'ROUBO_QUALIFICADO') return 'Roubo Qualificado'
    if (valor === 'LATROCINIO') return 'Latrocínio'
    if (valor === 'ASSOCIACAO_TRAFICO_DROGAS') return 'Associação para o tráfico de drogas'
    if (valor === 'ASSOCIACAO_CRIMINOSA') return 'Associação Criminosa'
    if (valor === 'ORGANIZACAO_CRIMINOSA') return 'Organização Criminosa'
    if (valor === 'FURTO') return 'Furto'
    if (valor === 'FURTO_QUALIFICADO') return 'Furto Qualificado'
    if (valor === 'FURTO_MEDIANTE_FRAUDE') return 'Furto Mediante Fraude'
    if (valor === 'ESTELIONATO') return 'Estelionato'
    if (valor === 'APROPRIACAO_INDEBITA') return 'Apropriação Indébita'
    if (valor === 'CORRUPCAO_ATIVA') return 'Corrupção Ativa'
    if (valor === 'CORRUPCAO_PASSIVA') return 'Corrupção Passiva'
    if (valor === 'PECULATO') return 'Peculato'
    if (valor === 'TRAFICO_DROGAS') return 'Tráfico de drogas'
    if (valor === 'HOMICIDIO_SIMPLES') return 'Homícidio Simples'
    if (valor === 'HOMICIDIO_QUALIFICADO') return 'Homícidio Qualificado'
    if (valor === 'FEMINICIDIO') return 'Feminicídio'
    if (valor === 'SEQUESTRO') return 'Sequestro'
    if (valor === 'CARCERE_PRIVADO') return 'Carcere Privado'
    if (valor === 'CRIME_DE_AMEACA') return 'Crime de Ameaça'
    if (valor === 'STALKING') return 'Stalking'
    if (valor === 'CRIME_DE_ESTUPRO') return 'Crime de Estupro'
    if (valor === 'VIOLENCIA_SEXUAL_MEDIANTE_FRAUDE') return 'Violência Sexual Mediante Fraude'
    if (valor === 'ASSEDIO_SEXUAL') return 'Assédio Sexual'
    if (valor === 'IMPORTUNACAO_SEXUAL') return 'Importunação Sexual'
    if (valor === 'FAVORECIMENTO_PROSTITUICAO') return 'Favorecimento a Prostituição'
    if (valor === 'ESTUPRO_VULNERAVEL') return 'Estupro de Vulnerável'
    if (valor === 'ATO_LIBIDINOSO') return 'Ato Libidinoso'
    if (valor === 'PATRIMONIO') return 'Crime contra o patrimônio'
    if (valor === 'TRANSITO') return 'Crime de Trânsito'
    if (valor === 'PORTE_ILEGAL_ARMA') return 'Porte ou uso ilegal de arma de fogo,acessário ou munição'
    if (valor === 'ADULTERACAO_IDENTIFICADOR_VEICULO') return 'Adulteração de sinal identificador de veículo automotor'
    if (valor === 'DIRECAO_ALCOOLICA') return 'Dirigir veículo automotor sob a influência de álcool ou outra substância psicoativa'
    if (valor === 'NAO_INFORMADO') return 'Não informado'
    if (valor === 'OUTRO') return 'Outro'
    return ''
  }

  const textoTipoPrisao = (valor) => {
    if (!valor) return ''
    if (valor === 'FLAGRANTE') return 'Flagrante'
    if (valor === 'MANDADO_PRISAO') return 'Cumprimento de mandado de Prisão'
    if (valor === 'NAO_INFORMADO') return 'Não informado : Detido conduzido pela policia penal'
    return ''
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      <div className={classes.resultsWrapper}>
        {processandoPericiando || processandoRegistros || !periciando ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <>
            <Card className={classes.headerCard}>
              <CardContent style={{ padding: '24px' }}>
                <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                  <Grid item xs={12} sm={6} md={7} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <ObjetoAvatar tipo="PERICIANDO" />
                    <Typography variant="h3" className={classes.caseTitle}>
                      {periciando.nome?.toUpperCase() || 'SEM NOME INFORMADO'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!processandoPericiando && <MenuAcoes idPericiando={params.id} id_caso={periciando.id_caso} />}
                  </Grid>
                </Grid>

                <Divider style={{ margin: '20px 0 24px 0' }} />

                <Typography variant="subtitle1" className={classes.caseSubtitle} style={{ marginTop: 0, marginBottom: '24px' }}>
                  {periciando.alcunha ? `ALCUNHA: ${periciando.alcunha.toUpperCase()}` : 'SEM ALCUNHA REGISTRADA'}
                </Typography>





                <Grid container spacing={3} className={classes.metaGrid} alignItems="stretch">
                  <Grid item xs={12} sm={6} md={3}>
                    <div className={classes.metaItem}>
                      <FingerprintIcon className={classes.metaIcon} />
                      <div className={classes.metaTextContainer}>
                        <Typography className={classes.metaLabel}>DOCUMENTO PRINCIPAL</Typography>
                        <Typography className={classes.metaValue}>{periciando.cpf ? `CPF: ${periciando.cpf.toUpperCase()}` : periciando.rg ? `RG: ${periciando.rg.toUpperCase()}` : 'NÃO INFORMADO'}</Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <div className={classes.metaItem}>
                      <WcIcon className={classes.metaIcon} />
                      <div className={classes.metaTextContainer}>
                        <Typography className={classes.metaLabel}>SEXO</Typography>
                        <Typography className={classes.metaValue}>{periciando.sexo?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <div className={classes.metaItem}>
                      <CakeIcon className={classes.metaIcon} />
                      <div className={classes.metaTextContainer}>
                        <Typography className={classes.metaLabel}>NASCIMENTO / IDADE</Typography>
                        <Typography className={classes.metaValue}>{`${periciando.dataNascimento ? moment(periciando.dataNascimento).format('DD/MM/YYYY') : 'NÃO INFORMADO'} ${calcularIdade(periciando.dataNascimento)}`}</Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <div className={classes.metaItem}>
                      <ScheduleIcon className={classes.metaIcon} />
                      <div className={classes.metaTextContainer}>
                        <Typography className={classes.metaLabel}>DATA DE ENTRADA</Typography>
                        <Typography className={classes.metaValue}>{moment(periciando.createdAt).format('DD/MM/YYYY HH:mm')}</Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <SecaoGenerica titulo="Dados do Periciando">
              <Grid container spacing={3}>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>NOME COMPLETO</Typography>
                  <Typography className={classes.metaValue}>{periciando.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>ALCUNHA</Typography>
                  <Typography className={classes.metaValue}>{periciando.alcunha?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>NOME SOCIAL</Typography>
                  <Typography className={classes.metaValue}>{periciando.nomeSocial?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>ESTADO CIVIL</Typography>
                  <Typography className={classes.metaValue}>{periciando.estadoCivil?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>CPF</Typography>
                  <Typography className={classes.metaValue}>{periciando.cpf?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>RG</Typography>
                  <Typography className={classes.metaValue}>{periciando.rg?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>NACIONALIDADE</Typography>
                  <Typography className={classes.metaValue}>{periciando.nacionalidade?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>NATURALIDADE</Typography>
                  <Typography className={classes.metaValue}>{periciando.naturalidadeCidade ? `${periciando.naturalidadeCidade?.toUpperCase()} / ${periciando?.naturalidade?.toUpperCase() || ' - '}` : periciando.naturalidade?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>

                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>OCUPAÇÃO</Typography>
                  <Typography className={classes.metaValue}>{periciando.ocupacao?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>ESCOLARIDADE</Typography>
                  <Typography className={classes.metaValue}>{periciando.escolaridade?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>FILIAÇÕES</Typography>
                  <Typography className={classes.metaValue}>{periciando.filiacoes?.map((filiacao) => filiacao.toUpperCase())?.join('; ') || 'NÃO INFORMADO'}</Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>ENDEREÇO</Typography>
                  <Typography className={classes.metaValue}>
                    {periciando?.endereco ? `${periciando.endereco?.toUpperCase()}, ${periciando.numeroResidencial?.toUpperCase() || ''}` : 'NÃO INFORMADO'}
                    {periciando.bairro || periciando.municipio ? ` - ${periciando.bairro?.toUpperCase() || ''}${periciando.municipio ? `, ${periciando.municipio.toUpperCase()}` : ''}` : ''}
                  </Typography>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <Typography className={classes.metaLabel}>COMPLEMENTO DO ENDEREÇO</Typography>
                  <Typography className={classes.metaValue}>{periciando.complemento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
                </Grid>

                {periciando.tipo && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Typography className={classes.metaLabel}>TIPO DO PERICIANDO</Typography>
                    <Typography className={classes.metaValue}>{periciando.tipo.toUpperCase()}</Typography>
                  </Grid>
                )}
                {periciando.naturezasSolicitacao?.length > 0 && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Typography className={classes.metaLabel}>NATUREZA DA SOLICITAÇÃO</Typography>
                    <Typography className={classes.metaValue}>{periciando.naturezasSolicitacao?.map((natu) => textoNaturezaSolicitacao(natu.natureza).toUpperCase()).join(', ')}</Typography>
                  </Grid>
                )}
                {periciando.tiposPrisao?.length > 0 && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Typography className={classes.metaLabel}>TIPO DA PRISÃO</Typography>
                    <Typography className={classes.metaValue}>{periciando.tiposPrisao?.map((tipoPrisao) => textoTipoPrisao(tipoPrisao.tipo).toUpperCase()).join(', ')}</Typography>
                  </Grid>
                )}
                {periciando.categoriasPrisao?.length > 0 && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Typography className={classes.metaLabel}>CATEGORIA DA PRISÃO</Typography>
                    <Typography className={classes.metaValue}>{periciando.categoriasPrisao?.map((cat) => textoCategoriaPrisao(cat.categoria).toUpperCase()).join(', ')}</Typography>
                  </Grid>
                )}
              </Grid>
            </SecaoGenerica>

            <SecaoGenerica titulo="Registros de Identificação Encontrados">
              {registros?.length ? (
                <Grid container spacing={2}>
                  {registros.map((registro) => (
                    <Grid key={registro.id} item md={12} sm={12} xs={12}>
                      <CardRegistroIdentificacao idRegistro={registro.id} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum registro pesquisado
                  </Typography>
                </Grid>
              )}
            </SecaoGenerica>

            <SecaoGenerica titulo="Informações Adicionadas">
              <Grid item xs={12}>
                <ListaInformacoes tipo="periciando" id={periciando.id} />
              </Grid>
            </SecaoGenerica>

            <SecaoGenerica titulo="Caso Relacionado">
              {periciando.caso || (periciando.casosPeric && periciando.casosPeric.length > 0) ? (
                <Grid container spacing={2}>
                  {periciando.caso && (
                    <Grid item md={3} sm={6} xs={12}>
                      <CardCaso caso={periciando.caso} handleClick={handleClickCaso} />
                    </Grid>
                  )}
                  {periciando.casosPeric?.map((caso) => (
                    <Grid key={caso.id} item md={3} sm={6} xs={12}>
                      <CardCaso caso={caso} handleClick={handleClickCaso} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum caso relacionado
                  </Typography>
                </Grid>
              )}
            </SecaoGenerica>

            <SecaoGenerica titulo="Exames Solicitados">
              {periciando.exSols && periciando.exSols.length ? (
                <Grid container spacing={2}>
                  {periciando.exSols.map((exameSolicitado) => (
                    <Grid key={exameSolicitado.id} item md={3} sm={6} xs={12}>
                      <CardExameSolicitado exameSolicitado={exameSolicitado} handleClick={handleClickExameSolicitado} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum exame solicitado
                  </Typography>
                </Grid>
              )}
            </SecaoGenerica>

            <SecaoGenerica titulo="Vestígios Extraídos">
              {vestigiosExtraidos && vestigiosExtraidos.length ? (
                <Grid container spacing={2}>
                  {vestigiosExtraidos.map((vestigio) => (
                    <Grid key={vestigio.id} item md={3} sm={6} xs={12}>
                      <CardVestigio vestigio={vestigio} handleClick={handleClickVestigio} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum outro vestígio foi extraído deste
                  </Typography>
                </Grid>
              )}
            </SecaoGenerica>

            <SecaoGenerica titulo="Arquivos Relacionados">
              {periciando.arqs?.length ? (
                <Grid container spacing={2}>
                  {periciando.arqs.map((arquivo) => (
                    <Grid key={arquivo.id} item md={2} sm={4} xs={6} className={classes.item}>
                      <ExibirArquivo id={arquivo.id} rotaLoadFile="/arquivo/periciando" />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum arquivo relacionado
                  </Typography>
                </Grid>
              )}
            </SecaoGenerica>
          </>
        )}
      </div>
    </Page>
  )
}
